import { Box, Grid } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { arraysOverlap } from '@utils/arrays';
import { navLink } from '@components/header/Header';
import { useState } from 'react';

export type MobileMenuSubMenuProps = {
  link: navLink;
  roles: string[];
  lioPayEnabled: boolean;
  theme: any;
  navLinkStyle: (theme: any) => any;
  activeLinkStyle: (theme: any) => any;
  closeHeaderMenu: () => void;
};

export const MobileMenuSubMenu = ({
  link,
  roles,
  lioPayEnabled,
  theme,
  navLinkStyle,
  activeLinkStyle,
  closeHeaderMenu,
}: MobileMenuSubMenuProps) => {
  const isOnParentPage = location.pathname.includes(link.url);
  const isExactMatch = link.url === location.pathname;
  const [subMenuOpen, setSubMenuOpen] = useState(isOnParentPage);

  return arraysOverlap(link.roles, roles) && (link.isVisible ? lioPayEnabled : true) ? (
    <Grid size={{ xs: 12 }} key={link.name} sx={{ marginY: '8px', display: 'flex', justifyContent: 'center' }}>
      {link.mobileSubLinks ? (
        <Box gap={1} sx={{ display: 'flex', textAlign: 'center', flexDirection: 'column' }}>
          <NavLink
            end
            onClick={(e) => {
              if (!isOnParentPage) {
                setSubMenuOpen((cur) => !cur);
              }

              e.preventDefault();
            }}
            to={link.url}
            style={navLinkStyle(theme)}
          >
            {link.name}
          </NavLink>
          {subMenuOpen && (
            <Box
              sx={{
                width: '100vw',
                py: 2,
                background: `${theme.palette.primary.main}30`,
              }}
            >
              <Box gap={1} sx={{ marginX: 'auto', display: 'flex', width: 'fit-content', flexDirection: 'column' }}>
                {link.mobileSubLinks
                  ?.filter((i) => arraysOverlap(i.roles, roles))
                  .map((subLink, index) => (
                    <NavLink
                      key={subLink.name}
                      end
                      onClick={closeHeaderMenu}
                      to={subLink.url}
                      style={({ isActive }) =>
                        isActive || (isExactMatch && index === 0) ? activeLinkStyle(theme) : navLinkStyle(theme)
                      }
                    >
                      {subLink.name}
                    </NavLink>
                  ))}
              </Box>
            </Box>
          )}
        </Box>
      ) : (
        <NavLink
          key={link.name}
          end
          onClick={closeHeaderMenu}
          to={link.url}
          style={({ isActive }) => (isActive ? activeLinkStyle(theme) : navLinkStyle(theme))}
        >
          {link.name}
        </NavLink>
      )}
    </Grid>
  ) : null;
};
